<script>
import { Submenu } from "element-ui";
export default {
  name: "aia-submenu",
  extends: Submenu,
  mounted() {}
};
</script>
<style></style>